import { ButtonHTMLAttributes, DetailedHTMLProps, FC } from 'react';

import BlueCheck from '@/assets/icons/BlueCheck';

import styles from './CheckButton.module.css';

type CheckButtonType = DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
  checked?: boolean;
};
const CheckButton: FC<CheckButtonType> = ({ children, checked = false, ...btnProps }) => {
  return (
    <button {...btnProps} className={`${styles.checkButtonStyle} ${checked ? `${styles.checked}` : ''}`}>
      {checked && (
        <>
          <BlueCheck className={styles.checkIconStyle} width='10px' height='10px' aria-hidden='true' />
          &nbsp;&nbsp;
        </>
      )}
      {children}
    </button>
  );
};
export default CheckButton;
